import fetch from 'cross-fetch';

/*
    Functions for Storyblok CMS integration, used for internationalization translations  

    This file is a .mjs so that it can be used by both the Vue app and a utility script.
*/

const tempRtsData = { url: 'https://www.endlesspools.com/', text: 'No thanks' };

const getStoryBlokData = (lang, url) => {
    return new Promise((resolve) => {
        if (lang && lang !== 'en-us') {
            url = url.replace('stories/', `stories/${lang}/`);
        }

        fetch(url)
            .then(response => {
              // console.log('response', response);
              return response.json()
            })
            .then((data)=>{
              const sizeInBytes = new TextEncoder().encode(JSON.stringify(data)).length;
              // console.log("response ("+sizeInBytes.toLocaleString()+" bytes) from " + url, data);
              return resolve(data)
            });
    });
};

const getShouldPrice = (data) => {
    return data?.static?.show_pricing ? true : false;
};

const getCountrySelectOpts = (data) => {
  // placeholder data in case Storyblok data not found
  const tempCountryComp = {
    component: 'inputs.country',
    default_selected: 'United States',
    error_message: 'Please include your country',
    label: 'Country',
    name: 'country',
    options: [{
      component: 'inputs.option',
      default_selected: true,
      name: 'United States',
      value: 'US',
    }],
    required: true,
  };
  // this all just finds the JSON data from Storyblok > Entries > Pool Builder > Contact > Inputs > Country Select
  const contact = data?.static?.contact;
  if (!contact || !contact.length) return tempCountryComp;
  const component = contact.find(obj => obj?.component && obj?.component?.toLowerCase && obj.component.toLowerCase() === 'contact');
  const inputs = component?.inputs;
  if (!component || !inputs || !inputs.length) return tempCountryComp;
  const countryComp = inputs.find(obj => obj?.component && obj?.component?.toLowerCase && obj?.component.toLowerCase() === 'inputs.country');
  return countryComp;
};

const getReturnURL = (data) => {
  const contact = data?.static?.contact;
  if (!contact || !contact.length) return tempRtsData;
  const component = contact.find(obj => obj?.component && obj?.component?.toLowerCase && obj.component.toLowerCase() === 'contact');
  const rtsIn = component?.return_to_site_link;
  const rttIn = component?.return_to_site_text;
  if (!rtsIn) return tempRtsData;
  if (rtsIn?.url) return { url: rtsIn?.url, text: rttIn || tempRtsData.text };
  else if (rtsIn?.cached_url) return { url: rtsIn?.cached_url, text: rttIn || tempRtsData.text };
  return tempRtsData;
};

// the big fetch of data from storyblok
const fetchLocalizedData = async (lang) => {
  let poolsData, accessoriesData, staticData, options;

  // Content Delivery API v1 and v2 API tokens are read-only and can be public
  const sbApiToken = '8blA8qmfucmNjTgldWwLuwtt';
  const sbApiMode = 'published';
  const cacheVersion = await fetch(`https://api.storyblok.com/v1/cdn/spaces/me?token=${sbApiToken}`)
    .then(response => response.json())
    .then((data) => {
      // console.log("cacheVersion response", data);
      return data.space.version;
    }
    );

  /*
      Notes on Storyblok API calls:
      - path param is slug of entry
      - cv is used when sending multiple calls to ensure data is retrieved from the same version
      - resolve_relations says to populate other entries related to the specified entry by select field
  */
  const promises = [
    new Promise((resolve) => {
      getStoryBlokData(lang, `https://api.storyblok.com/v1/cdn/stories/pool-data?version=${sbApiMode}&token=${sbApiToken}&cv=${cacheVersion}&resolve_relations=data.line.models`).then((data) => {
        poolsData = data.story.content.pools;
        /*
          In StoryBlok, eventually, it may be a good idea to move the option strings/images to be in the 
          "pools" content entry, like location choices now are (or just make a new content entry for options). 
          We could still allow CMS-ability for available option choices per pool by changing the schema of 
          "data.config" to just use the "multi-list" field type for option choices (rather than "blocks" field 
          type with whitelisted components), and those lists can use string IDs as values that map to 
          string IDs of option choices located in the "pools" content entry.
          That will allow for simpler code in this codebase and less redundancy in StoryBlok.
        */
        options = {
          location: data.story.content.location_option_choices,
          size: data.story.content.size_option_labels
        }
        resolve();
      });
    }),
    new Promise((resolve) => {
      getStoryBlokData(lang, `https://api.storyblok.com/v1/cdn/stories/accessory-data?version=${sbApiMode}&token=${sbApiToken}&cv=${cacheVersion}&resolve_relations=accessory-data.accessories`).then((data) => {
        accessoriesData = data.story.content.accessories;
        // console.log('data.story.content.accessories', data.story.content.accessories);
        resolve();
      });
    }),
    new Promise((resolve) => {
      getStoryBlokData(lang, `https://api.storyblok.com/v1/cdn/stories/pool-builder?version=${sbApiMode}&token=${sbApiToken}&cv=${cacheVersion}`).then((data) => {
        staticData = data.story.content;
        // console.log('data.story.content', data.story.content);
        resolve();
      });
    })
  ];

  await Promise.all(promises);

  // organize data a little bit
  const result = {
    poolCategory: {},
    series: {},
    models: {},
    accessories: accessoriesData,
    static: staticData,
    options
  };

  // for each category (family of pools)
  poolsData.forEach(poolSet => {
    const theCategory = result.poolCategory[poolSet.tag] = poolSet;

    // for each series (at one time called lines) in the category
    theCategory.lines.forEach(series => {
      result.series[series.tag] = series;

      const models = series.models;

      // for each pool within the series
      models.forEach(model => {
        model = { ...model.content, sbuid: model.uuid };
        result.models[model.tag] = model;
      });
    });
  });

  return result;
}

export { getShouldPrice, getCountrySelectOpts, getReturnURL, fetchLocalizedData, tempRtsData }